import React, { createContext, useContext } from "react";

// Create the context
const FromPageContext = createContext(undefined);

export const useFromPage = () => {
  const context = useContext(FromPageContext);
  if (!context) {
    throw new Error("Context must be used within a useFromPage");
  }
  return context;
};

export const FromPageProvider = ({ children }) => {
  const isAssigningTickets = /\/event\/[^/]+\/seatmap\/assign/.test(
    window.location,
  );

  const isPackage = /package/.test(window.location);
  const isAssigningToFan = /\/package\/[^/]+\/seatmap\/assign/.test(
    window.location,
  );
  const fromPackageHolders = /package-holders/.test(window.location);
  const fromAssignPackages = /assign-packages/.test(window.location);

  return (
    <FromPageContext.Provider
      value={{
        isAssigningTickets,
        isPackage,
        isAssigningToFan,
        fromAssignPackages,
        fromPackageHolders,
      }}
    >
      {children}
    </FromPageContext.Provider>
  );
};
